require('../../../retail/js/feature/component-two-section-grid');